import React from "react";

export default function VideoBanner({ data, children }) {
  return (
    <div className="relative w-full lg:h-screen h-screen top-0 z-[0]">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-[0]"
      >
        <source src={data?.video} type="video/mp4" />
      </video>
      <div className="z-[1]">{children}</div>
    </div>
  );
}
